import { HttpStatusCode } from 'axios';

import { EventApplyOption } from 'modules/calendar/core/enum';
import { EventSession } from 'modules/calendar/core/type';

import { apiCall } from 'hooks/service';

export const getListEventSessions = async (
  filters: Record<string, string>,
): Promise<EventSession[] | null> => {
  const response: {
    success: boolean;
    data: EventSession[];
  } = await apiCall({
    method: 'GET',
    url: `/calendars/events/sessions?filter=${encodeURIComponent(JSON.stringify(filters))}`,
    showError: true,
    isLoading: true,
  });

  if (response && response.success) {
    const formattedEventSessions = response.data.map((item) => ({
      ...item,
      id: item.id,
      title: item.name,
      start: new Date(item.start),
      end: new Date(item.end),
    }));

    return formattedEventSessions;
  }

  return null;
};

export const deleteEvent = async (
  sessionId: string,
  applyOption: EventApplyOption,
): Promise<boolean> => {
  const response: {
    statusCode: number;
  } = await apiCall({
    method: 'DELETE',
    url: `/calendars/events/sessions/${sessionId}`,
    config: {
      params: {
        applyOption,
      },
    },
    showError: true,
    isLoading: true,
  });

  if (response.statusCode === HttpStatusCode.Ok) return true;

  return false;
};

export const generateQRCode = async (sessionId: string): Promise<string | null> => {
  const response: {
    statusCode: number;
    data: string;
  } = await apiCall({
    method: 'POST',
    url: `/qr/event-sessions/${sessionId}/generate`,
    showError: true,
    isLoading: true,
  });

  if (response.statusCode === HttpStatusCode.Ok) return response.data;

  return null;
};
